module.exports = __webpack_public_path__ + "static/media/poppins-semibold-webfont.a68d7a30.ttf";